export default {
  more: '查看更多',
  home: '首页',
  todo: '待办',
  workbench: '工作台',
  // todo 这个英文文案只是占位，到时要换，中文是正确的。
  workbenchNoRecentdata: '暂无最近使用',
  // todo 这个英文文案只是占位，到时要换，中文是正确的。
  workbenchRecentUsed: '最近使用',
  packUp: '收起',
  noAccessPermission: '暂无权限访问',
  err: '如需开通权限，请联系：',
  // errGoToWorkflow: '请前往Workflow开通权限',
  // viewActivationProcess: '查看开通流程',
  contact1: '陆哲卿（zheqing.lu@nio.com）',
  contact2: '杜海涛（tony.du@nio.com）',
  loading: '加载中...',
  globalCopyErrMsg: '字符数超过 {max} ，禁止复制',
  niocall: {
    btns: {
      microphoneOn: {
        label: '麦克风已开'
      },
      microphoneOff: {
        label: '麦克风已关'
      },
      hangup: {
        label: '挂断'
      }
    },
    status: {
      audioOn: {
        label: '正在进行语音通话'
      },
      callEnd: {
        label: '通话已结束'
      },
      repeatCall: {
        label: '当前正在通话，请勿重复拨打'
      },
      waitPeer: {
        label: '正在等待对方接受邀请'
      }
    },
    callParams: {
      errCode: {
        callOngoing: '当前有通话正在进行中，请稍后再试！',
        calledBusy: '忙线未接听',
        callingBusy: '呼叫失败，当前坐席账号有其他通话正在进行中',
        unsupportedVehicleVersion: '该车辆版本过低，不支持NIOCall，请通过电话联系'
      },
      errorAndTry: {
        firLine: '获取参数异常，请稍后重试！',
        label: '错误码：'
      }
    },
    startCall: {
      noAnswerAndTry: {
        label: '暂时无人接听，请稍后再试'
      },
      network: {
        disconnected: '网络异常，连接已中断',
        qualityPoor: '当前网络状况差',
        reconnectFail: '自动重连失败'
      },
      initFail: {
        reconnecting: '正在自动重连，请稍等',
        steamInitTimeout: '音频初始化超时。若拨打不通，可尝试 1、挂断当前通话。2、刷新浏览器。3、重新拨打。',
        label: '发起通话失败！'
      }
    },
    callPanel: {
      eventDetailLink: {
        label: '事件详情'
      },
      wearHeadphones: {
        label: '请佩戴外置耳机'
      }
    }
  },
  sdk: {
    location: {
      ask: '是否允许"NPDS"获取此设备的位置信息？',
      confirm: '允许',
      reject: '禁止'
    }
  },
  errorPCInfo: '请在内网/外网VPN环境下, 点击以下按钮申请',
  errorMolInfo: '移动端暂不支持权限申请,请前往PC端NPDS再试',
  errorToApply: '立即申请',
  mine: '我的'
}
